import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { List, Button, Popconfirm } from "antd";
import { MyIcon, IMG_DEFAULT } from "../../common/baseConfig";
import { common } from "../../utils";
import NoneData from "../common/NoneData";
export class CourseManageMyCollect extends Component {
  state = {
    curPage: 1,
  }
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentDidMount() {
    this.onLoadMyComment();
  }
  onLoadMyComment() {
    this.props.actions.fetchGetMyCollect({
      PageSize: 5,
      PageIndex: this.state.curPage,
      PageStatus: 1,
    })
  }
  renderItem(item) {
    return (
      <div key={item.BusID} className="my-collect-list-item">
        <div className="content">
          <img src={item.CoverPath ? item.CoverPath + '?x-oss-process=image/resize,m_fixed,h_90,w_160' :  IMG_DEFAULT} alt="" onClick={() => {
            this.props.history.push(`/course/detail/${item.BusID}`);
          }} />
          <h1>
            <p>{item.CourseName}</p>
            <p>授课老师：{item.TeacherName || "匿名"}</p>
            <p>¥{item.PreferentialPrice.toFixed(2)}</p>
          </h1>
        </div>
        <div className="btns">
          <p>
            <Button onClick={() => {
              if (item.IsBuy === 0) {
                this.props.actions.fetchGetIsOrder({ BusId: item.BusID, BusType: 0 }).then(res => {
                  if (res.SuccessResponse) {
                    common.GetIsOrder(res.Data, this.props.history, '课程', () => {
                      //直接生成订单跳支付
                      this.props.actions.fetchDirectOrder({
                        BusType: 0, // 0课程1 课程包 2 课程阶段
                        BusId: item.BusID
                      }).then(res => {
                        if (res.SuccessResponse) {
                          let params = {};
                          params.OrderId = res.Data.OrderId;
                          params.Money = res.Data.Price;
                          params.OrderName = "课程支付";
                          params.IsStudent = 1;
                          this.props.actions.fetchUnifiedCreateOrder(params).then(res => {
                            if (res.SuccessResponse) {
                              
                              this.props.history.push(`/paytype/${res.Data.OrderId}`);
                            }
                          })
                        }
                      })
                    });
                  }
                })
              } else {
                this.props.history.push(`/course/detail/${item.BusID}`)
              }
            }} type={item.IsBuy === 0 ? "theme" : "theme2"} className="btn">{item.IsBuy === 0 ? "立即购买" : "进入学习"}</Button>
          </p>
          <Popconfirm placement="top" title={"确认取消该收藏吗?"} onConfirm={() => {
            this.props.actions.fetchCancelCollection({
              BusID: item.BusID,
              BusType: 2
            }).then(res => {
              if (res.SuccessResponse) {
                this.onLoadMyComment();
              }
            })
          }} okText="确认" cancelText="取消">
            <MyIcon type="iconshanchu1" className="del" />
          </Popconfirm>
        </div>
      </div>
    )
  }
  render() {
    const { fetchGetMyCollectPending,
      fetchGetMyCollectSuccess,
      fetchGetMyCollectTotal } = this.props.center;
    return (
      <div className="center-course-manage-my-collect">
        {
          fetchGetMyCollectSuccess && fetchGetMyCollectSuccess.length > 0 &&
          <div className="my-collect-list">
            <List
              itemLayout="horizontal"
              size="large"
              pagination={{
                onChange: page => {
                  this.setState({
                    curPage: page,
                  }, () => {
                    this.onLoadMyComment();
                  })
                },
                current: this.state.curPage,
                total: fetchGetMyCollectTotal,
                pageSize: 5,
              }}
              loading={fetchGetMyCollectPending}
              dataSource={fetchGetMyCollectSuccess}
              renderItem={item => this.renderItem(item)}
            />
          </div>
        }
        {
          fetchGetMyCollectSuccess && fetchGetMyCollectSuccess.length === 0 &&
          <div className="noneData">
            <NoneData type={2} />
          </div>
        }
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CourseManageMyCollect);



// WEBPACK FOOTER //
// ./src/features/center/CourseManageMyCollect.js